import useGetCustomerMockups from './useGetCustomerMockups'

export default useGetCustomerMockups
